// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32f4Q","footer":"styles_footer__1Lb2b"};